export default __webpack_public_path__ + "static/media/CreditCounselingGetStarted.805d7d0d.svg";